import * as gfunctions from '../../../js/generalFunctions';

CCL.videoPlayerModal = {
  autoload: [
    ['openVideoPlayer', $('.CCL-youtube-link').length > 0]
  ],

  dynamicURLData: {},

  openVideoPlayer() {
    $('.CCL-youtube-link').click((event) => {
      event.preventDefault();
      const embedOnURL = this.generateEmbedURl($(event.currentTarget).attr('data-audioonurl'));
      const embedOffURL = this.generateEmbedURl($(event.currentTarget).attr('data-audiooffurl'));
      this.dynamicURLData = {
        audioOnUrl: embedOnURL,
        audioOffUrl: embedOffURL
      };
      this.playCarnivalVideo(this.dynamicURLData);
    });
  },

  generateEmbedURl(url) {
    const getID = this.getVideoId(url);
    const videoURL = `//www.youtube.com/embed/${getID}`;
    return videoURL;
  },

  getVideoId(videoUrl) {
    /* eslint-disable */
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = videoUrl.match(regExp);
    if (match && match[2].length === 11) {
      return match[2];
    } else {
      return 'error';
    }
    /* eslint-enable */
  },

  async playCarnivalVideo(dynamicData) {
    gfunctions.showLoader();
    try {
      const inputHtmlObj = {
        url: '/_ui/responsive/ccl/assets/templates/video-modals/ccl-video-modal.html',
        type: 'GET'
      };
      const response = await gfunctions.doAjax(inputHtmlObj);
      const html = gfunctions.createDynamicHTML(response, dynamicData);
      $('#video-player-ccl').empty().append(html);
      gfunctions.showModal('video-player-modal');
      gfunctions.hideLoader(); // call all javascript event after above html load
      this.modalClickEvents();
    } catch (err) {
      gfunctions.hideLoader();
      const cartAPIError = { customError: err };
      console.log(cartAPIError);
    }
  },

  modalClickEvents() {
    $('#video-player-modal').on('hidden.bs.modal', () => {
      $('#iframeYoutube').attr('src', '#');
    });

    $('.videoCloseBtn').click((e) => {
      $('#iframeYoutube').attr('src', '#');
      if (gfunctions.detectmob()) {
        $('.mobileComponent .CCL-youtube-link').addClass('video-focus');
        setTimeout(() => {
          $('.mobileComponent .CCL-youtube-link').focus();
        });
      } else {
        $('.desktopComponent .CCL-youtube-link').addClass('video-focus');
        setTimeout(() => {
          $('.desktopComponent .CCL-youtube-link').focus();
        });
      }
    });

    $('.radio-toggle').click((e) => {
      const getSelectedRadio = e.currentTarget.innerText.trim();
      if (getSelectedRadio === 'off') {
        $('#iframeYoutube').attr('src', this.dynamicURLData.audioOffUrl);
      } else {
        $('#iframeYoutube').attr('src', this.dynamicURLData.audioOnUrl);
      }
      $('.audio-desc-toggle').find('input:checked').focus();
    });

    $('#ad-disabled0').on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        $(() => {
          $('.videoCloseBtn').focus();
        });
      }
    });
    $('#ad-enabled0').on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        $(() => {
          $('.videoCloseBtn').focus();
        });
      }
    });
    $('#closeBtn').on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        $('.audio-desc-toggle').find('input:checked').focus();
      }
    });
    // $('body').on('keydown', e => {
    //   if (e.which === 27) { // Esc Key
    //     e.preventDefault();
    //     e.stopPropagation();
    //     gfunctions.hideModal('cclVideoModal');
    //   }
    // });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-video-player/video-player.js